class PictureGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const lightGalleryInstance = lightGallery(this.querySelector('.picture-gallery-container'), {
      licenseKey: '80E64CCC-70E5463C-AEF10431-9FEB3C14',
      plugins: [lgThumbnail],
      speed: 500,
      thumbnail: true,
      download: false,
      getCaptionFromTitleOrAlt: false,
      mobileSettings: {
        controls: true,
      }
    });
    
    const macyInstance = Macy({
      container: '.picture-gallery-container',
      mobileFirst: true,
      columns: 1,
      margin : {
        x: 30,
        y: 30
      },
      breakAt: {
        700: {
          columns: 2,
        },
        1200: {
          columns: 4
        }
      }
    });
  }
}

customElements.define('picture-gallery', PictureGallery);
